import { requestMethod } from "../../config";
import config from "../../env.config";
import { fetch } from "../../shared/services/api.service";
import { checkApiSuccess } from "../../utils";

export const getUserEngagement = (payload) => {
  return async (dispatch) => {
    const requestPayload = {
        method: requestMethod.GET,
        url: `${config.BASE_URL.BASE_API_URL}/task/getUserEngagement`,
        params: payload,
      },
      response = await fetch(requestPayload, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const updateUserEngagement = async (payload) => {
  const requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/task/updateUserEngagement`,
      data: payload,
    },
    response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const updateProjectEngagement = async (payload) => {
  const requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/task/updateProjectEngagement`,
      data: payload,
    },
    response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};
